var notificationType = {
  INFORMATION: 1,
  ERROR: 2,
  WARNING: 3,
  SUCCESS: 4,
  CONFIRMATION: 5,
  NO_ICON: 6
};
module.exports = notificationType;
